import React from 'react';
import { Button, Icon, Table, Header, Popup, Loader, Form, Segment, Grid } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';

import { IconHeader, FiltersOnStyle, HeaderCursor } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import { fetchAcademicYears } from '../../Lookups/util';
import {ExportReactCSV} from "../../util/ExportCSV";
import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const fetchCurrentSemester = () => axios.get('semester/current');

const NoDataMessage = () => <p>Nema studenata.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema studenata.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class SProgramStudents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            studyPrograms: [],
            academicYears: [],
            semesters: [],
            student: null,
            academicYear: '',
            semester: '',
            currentSemester: '',

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: false,
            showStudentInfo: false,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            isLoading: false,
            results: [],
            excelData: []
        };

        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.getStudentsBySP = this.getStudentsBySP.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        axios.all([fetchAcademicYears(), fetchCurrentSemester()])
            .then(axios.spread((academicYearsRes, currentSemesterRes) => {
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    academicYears, semester: currentSemesterRes.data.id
                });
                axios.get('/academic-years/current')
                    .then(res => {
                        this.setState({ academicYear: res.data.id }, () => { this.getSemesters(this.state.academicYear); });
                    });

                this.getStudentsBySP(currentSemesterRes.data.id);
            }))
            .catch(err => {
                console.log('Failed to fetch academic years, study programs or current semester');
            });
    }


    fetchStudyPrograms() {
        axios.get('study-programs/by-organizational-unit')
            .then(res => {
                const studyPrograms = res.data.filter(el => el.studyProgram.studyProgramStatus._key !== 'archived')
                    .sort((a, b) => a.studyProgram.studyProgramStatus.id - b.studyProgram.studyProgramStatus.id)
                    .map(el => ({
                    value: el.studyProgram.id, text: el.studyProgram.studyProgramBasic.name + ' - ' + el.studyProgram.name, key: el.studyProgram.id, description: el.studyCycles[0].name
                }));
                this.setState({
                    studyPrograms: studyPrograms
                });
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({ [name]: value });

        if (name === 'academicYear') {
            this.setState({ semester: null });
            this.getSemesters(value);
        }

        if (name === 'semester') {
            this.getStudentsBySP(value);
        }
    }

    getSemesters(id) {
        axios.get(`semester/by-academic-year/${id}`)
            .then(res => {
                this.setState({
                    semesters: res.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name.name + ' ' + el.academicYear.name
                    }))
                });
            });
    }


    getStudentsBySP(semesterId) {
        this.setState({ loading: true });
        let obj = {};

        axios.post(`students/filter-by-semester/${semesterId}/${!!this.props.gradAgain}`, { ...obj })
            .then(res => {
                this.setState({
                    data: res.data.sort((a, b) => b.firstName < a.firstName).map(el => ({
                        ...el,
                        studyType: el.studyTypeId ? this.props.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                        department: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : '',
                    })),
                    loading: false
                });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.index},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyTypeId ? this.props.studyTypes.find(e => e.id === el.studyTypeId).name : null},
                    { value: el.studyProgramSemesterName},
                    { value: el.studyCycleName},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton && this.state.results.length === 0) {
            return this.state.filterData;
        }

        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getFilterData(studyProgramId, studyProgramSemesterName) {
        this.setState({ loading: true });
        let docFilter = {};

        if (studyProgramId) docFilter = { ...docFilter, studyProgramId };
        if (studyProgramSemesterName) docFilter = { ...docFilter, studyProgramSemesterName };

        axios.post(`students/filter-by-semester/${this.state.semester}/${!!this.props.gradAgain}`, { ...docFilter })
            .then(res => {
                const filterData = res.data.sort((a, b) => b.firstName < a.firstName).map(el => ({
                    ...el,
                    studyType: el.studyTypeId ? this.props.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                }));
                this.setState({
                    filterData, loading: false, showFiltersOnButton: true, showFilterMode: false
                });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.index},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyTypeId ? this.props.studyTypes.find(e => e.id === el.studyTypeId).name : null},
                    { value: el.studyProgramSemesterName},
                    { value: el.studyCycleName},
                    // { value: el.englishName ? el.englishName : '' },
                    // { value: el.comment ? el.comment : ''},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        console.log('tu');
        const excelData = this.state.data.map(el => ([
            { value: el.lastName},
            { value: el.firstName},
            { value: el.index},
            { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
            { value: el.studyProgramBasicName},
            { value: el.studyProgramName},
            { value: el.studyTypeId ? this.props.studyTypes.find(e => e.id === el.studyTypeId).name : null},
            { value: el.studyProgramSemesterName},
            { value: el.studyCycleName},
            // { value: el.englishName ? el.englishName : '' },
            // { value: el.comment ? el.comment : ''},
        ]));
        this.setState({excelData: excelData});
        console.log('eee', this.state.excelData)
        this.setState({
            showFilterMode: false, showFiltersOnButton: false, loading: false
        });
        return this.state.data;
    }
    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    render() {

        // const headersForExport = [
        //     { label: 'Prezime', key: 'lastName' },
        //     { label: 'Ime', key: 'firstName' },
        //     { label: 'Index', key: 'index' },
        //     { label: 'Odsjek', key: 'departmentsSPOU[0].organizationalUnitName' },
        //     { label: 'Studijski program', key: 'studyProgramBasicName' },
        //     { label: 'Plan i program', key: 'studyProgramName' },
        //     { label: 'Tip studiranja', key: 'studyType' },
        //     { label: 'Semestar', key: 'studyProgramSemesterName' },
        //     { label: 'Ciklus studija', key: 'studyCycleName'},
        // ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 200 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Tip studiranja', width: { wpx: 200 } },
                    { title: 'Semestar', width: { wpx: 200 } },
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        if (this.state.showStudentInfo === true) {
            return <Redirect push to={{ pathname: '/spisak-studenata/informacije-o-studentu', state: { student: this.state.student } }} />;
        }
        return (
            <div>
                <Header style={IconHeader} floated="right" >
                    {this.state.showFiltersOnButton && <Button
                        onClick={this.filtersOff}
                        floated="left"
                        icon
                        labelPosition="right"
                        color="orange"
                        size="small"
                        style={FiltersOnStyle}
                    ><Icon className="remove" onClick={this.filtersOff} />
                        Filtriranje uključeno!
                    </Button>}
                    {this.getDataToRender().length ? <Popup
                        trigger={<Icon
                            link
                            circular
                            basic
                            floated="right"
                            name="filter"
                            onClick={() => {this.fetchStudyPrograms(); this.setState({ showFilterMode: !this.state.showFilterMode }); }}
                        />}
                        content="Filtriraj podatke"

                        hideOnScroll
                        position="top center"
                    />
                        : null}
                </Header>
                <br />

                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field >
                            <label>Semestar</label>
                            <Form.Dropdown
                                placeholder="Odaberite semestar"
                                value={this.state.semester}
                                onChange={this.handleInputChange}
                                name="semester"
                                options={this.state.semesters}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field />
                    </Form.Group>
                </Form>

                {this.state.showFilterMode && <Segment secondary clearing><Filters
                    onFilterData={this.getFilterData}
                    studyPrograms={this.state.studyPrograms}
                    filtersOff={this.filtersOff}
                    semester
                /></Segment>
                }
                {this.state.loading && <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /><br /></div>}
                {currentPosts.length && !this.state.loading ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={15} >
                                    <Grid columns={2} stackable>

                                        <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['studyProgramBasicName', 'name', 'department', 'lastName', 'firstName', 'index', 'studyProgramName', 'studyType', 'studyProgramSemesterName', 'studyCycleName']} />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign={'center'}>
                                            <ExcelFile filename={this.props.gradAgain ? "Spisak apsolvenata ponovaca" : "Spisak upisanih studenata u trenutni semestar"} element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            {/*<Table.Row>*/}
                            {/*    <Table.HeaderCell colSpan={15} >*/}
                            {/*            <span> {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Spisak upisanih studenata u trenutni semestar" />}*/}
                            {/*                <SearchTableData data={this.state.showFiltersOnButton ? this.state.filterData :  this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index','studyCycleName','studyProgramName', 'studyProgramBasicName', 'studyType', 'studyProgramSemesterName', 'department']} />*/}
                            {/*            </span>*/}
                            {/*    </Table.HeaderCell>*/}
                            {/*</Table.Row>*/}
                            <Table.Row>
                                <Table.HeaderCell width={1} >R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Prezime i ime</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Broj indexa</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Odsjek</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Studijski program</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Semestar</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Ciklus studija</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {currentPosts.map((el, index) =>
                            (<Popup
                                trigger={<Table.Row
                                    key={index}
                                    style={HeaderCursor}
                                    onClick={() => {
                                        this.setState({ student: el, showStudentInfo: true });
                                        localStorage.setItem('student', JSON.stringify(el));
                                    }}
                                >
                                    <Table.Cell verticalAlign="middle" >
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.

                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Row verticalAlign="middle">
                                                <Grid.Column width="10">
                                                    <span >{el.lastName} {el.firstName}</span>
                                                </Grid.Column>
                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                    {/*<span style={{ color: '#a6a4a1' }}>{el.index}</span>*/}
                                                    <span style={{ color: '#a6a4a1' }}>{el.studyType ==='redovan' ? 'R': el.studyType==='redovan-samofinansirajući' ? 'RSF': el.studyType==='vanredan' ? 'V': el.studyType==='paralelan'? 'P':'DL'}</span>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        {/*{el.lastName} {el.firstName}*/}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.index}
                                        {/*{el.studyCycleName}*/}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}
                                        {/*{el.studyProgramBasicName}*/}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                        {/*{el.studyProgramName}*/}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.studyProgramSemesterName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.studyCycleName}
                                    </Table.Cell>
                                </Table.Row>}
                                content="Prikaz informacija o studentu"
                                hideOnScroll
                                position="left center"
                            />))}
                        </Table.Body>
                    </Table>
                    : this.state.showFiltersOnButton ? <NoFilterDataMessage />
                        : (this.state.semester && !this.state.loading) ? <NoDataMessage /> : '' }
                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/SProgramStudents.js